
import React from 'react';
import { Waves, Anchor, LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

export const DashboardHeader = () => {
  const { signOut, user, profile } = useAuth();

  const handleLogout = async () => {
    await signOut();
  };

  const displayName = profile?.full_name || user?.user_metadata?.full_name || user?.email || 'Yacht Broker';
  const initials = profile?.full_name?.charAt(0) || user?.user_metadata?.full_name?.charAt(0) || user?.email?.charAt(0) || 'Y';

  return (
    <header className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white shadow-2xl border-b border-slate-700">
      <div className="container mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="relative">
              <Waves className="h-12 w-12 text-emerald-400" />
              <Anchor className="h-6 w-6 text-white absolute -bottom-1 -right-1" />
            </div>
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                Orca AI
              </h1>
              <p className="text-slate-300 text-sm font-medium">Yacht Charter Intelligence Dashboard</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-6">
            <div className="text-right">
              <p className="text-sm text-slate-400">Welcome back</p>
              <p className="font-semibold text-slate-100">
                {displayName}
              </p>
            </div>
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full flex items-center justify-center ring-2 ring-emerald-400/30">
              <span className="text-white font-bold text-sm">
                {initials}
              </span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="border-slate-600 text-slate-100 hover:bg-slate-700 hover:text-white bg-slate-800/50"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
